import $ from 'jquery';
import 'jquery.cookie';
import Backbone from 'source/lib/backbone';
import ajaxrequest from 'wg-ajaxrequest';
import Settings from './settings_model';


window.Settings = window.Settings || {};

$.ajaxSetup({
    traditional: true
});

function enableCsrfToken(appid) {
    const cookieName = Settings.get('App.CsrfCookieName') ||
        `${appid || Settings.appName || ''}_csrftoken`;
    const cookiePath = Settings.get('App.CsrfCookiePath') || '/id/';
    const CSRF_TOKEN = Settings.get('Request.CSRF_TOKEN') ||
        $.cookie(cookieName) ||
        window.Settings.CSRF_TOKEN;

    // Sync token by all place
    $.cookie(cookieName, CSRF_TOKEN, { path: cookiePath });
    window.Settings.CSRF_TOKEN = CSRF_TOKEN;
    Settings.set({ CSRF_TOKEN });

    return CSRF_TOKEN;
}

function ajax(params) {
    const CSRF_TOKEN = Backbone.enableCsrfToken();

    if (params.type === 'POST' && !CSRF_TOKEN) {
        Settings.syncAccountState(true);
    }
    return ajaxrequest.submit(params.data, params);
}

Backbone.enableCsrfToken = enableCsrfToken;
Backbone.ajax = ajax;

export {
    ajax,
    enableCsrfToken
};



// WEBPACK FOOTER //
// ./static-source/js/lib/backbone_wg_ajax.js